const AppConstants = {
  CSS_CLASS_ALERT_ERROR: 'alert-danger',
  CSS_CLASS_ALERT_SUCCESS: 'alert-success',
  CSS_CLASS_ALERT_WARNING: 'alert-warning',
  EVENT_SHOW_LOADING: 'showLoading',
  EVENT_REMOVE_LOADING: 'removeLoading',
  ROTA_DETALHA_VARIAVEL: 'detalhaVariavel',
  ROTA_DETALHA_GRUPO: 'detalharGrupoRede',
  ROTA_DETALHA_REGRA: 'detalharRegraNegocio',
  documentPath: 'bi/indicacao/',
  number: 57,
  document: 'documentoIndicacao',
  listaGrauInstrucao: [
    // { codigo: 3, valor: 'Atualização' },
    { codigo: 2, valor: 'Pós-Graduação' },
    { codigo: 7, valor: 'Residência' },
    { codigo: 4, valor: 'Especialização' },
    { codigo: 5, valor: 'Mestrado' },
    { codigo: 6, valor: 'Doutorado' },
  ],
  especialidadesGeral: [
    {
      codigo: 1,
      titulo: 'Clínica Geral',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: true,
      justificativa: null,
    },
    {
      codigo: 5,
      titulo: 'Cirurgia',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: true,
      justificativa: null,
    },
    {
      codigo: 2,
      titulo: 'Dentística',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: true,
      justificativa: null,
    },
    {
      codigo: 32,
      titulo: 'Disfunção Temporo Mandibular',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: true,
      justificativa: null,
    },
    /*INATIVAÇÃO FEITA PELA DEM0010349*/ 
    /*{
      codigo: 18,
      titulo: 'Emergência',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: false,
      justificativa: null,
    },*/
    {
      codigo: 3,
      titulo: 'Endodontia',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: true,
      justificativa: null,
    },
    {
      codigo: 15,
      titulo: 'Estética',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: true,
      justificativa: null,
    },
    {
      codigo: 31,
      titulo: 'Estomatologia',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: true,
      justificativa: null,
    },
    {
      codigo: 16,
      titulo: 'Implante',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: false,
      justificativa: null,
    },
    {
      codigo: 27,
      titulo: 'Odontogeriatria',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: true,
      justificativa: null,
    },
    /*INATIVAÇÃO FEITA PELA DEM0010349*/ 
    /*{
      codigo: 20,
      titulo: 'Odontologia Legal',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: true,
      justificativa: null,
    },*/
    {
      codigo: 9,
      titulo: 'Odontopediatria',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: true,
      justificativa: null,
    },
    {
      codigo: 6,
      titulo: 'Ortodontia',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: false,
      justificativa: null,
    },
    {
      codigo: 11,
      titulo: 'Ortopedia Funcional dos maxilares',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: false,
      justificativa: null,
    },
    {
      codigo: 10,
      titulo: 'Pacientes Especiais',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: true,
      justificativa: null,
    },
    {
      codigo: 4,
      titulo: 'Periodontia',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: true,
      justificativa: null,
    },
    {
      codigo: 13,
      titulo: 'Prótese Dentária',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: true,
      justificativa: null,
    },
    /*INATIVAÇÃO FEITA PELA DEM0010349*/ 
    /*
    {
      codigo: 14,
      titulo: 'Radiologia',
      valorSelecionado: null,
      grauInstrucao: null,
      certificado: null,
      base64: null,
      loading: false,
      incluiClinicoGeral: false,
      justificativa: null,
    },*/
  ],
};

export default Object.freeze(AppConstants);
